import { Type } from '@deqo/foundation';
import { Component } from '../../../concepts/objects';
import { LibraryBase } from '../../canvas/LibraryBase';
import { Activator, Connector } from '../../Container';

export interface ExportSource {
    readonly id: string;
    readonly label: string;
    readonly default: boolean;
    canRead(): boolean;
    stats(types: string[]): Readonly<Record<string, number>>;
    read(): Component[];
}

export interface ExportSourceProvider {
    readonly id: string;
    get(): ExportSource[];
}

export class ExportSourceLibrary extends LibraryBase<ExportSourceProvider> {
    protected index = (item: ExportSourceProvider) => item.id;
}

export const inExportSourceProvider = (providerType: Type<ExportSourceProvider>) => Connector(r => {
    const activator = r.call(Activator);
    const library = r.call(ExportSourceLibrary);
    library.register(activator.call(providerType));
});
